<template>
  <div v-if="wrapshow">
    <!-- :style="{ height: '80%' }" -->
    <van-popup v-model="open" position="bottom" @closed="wrapshow = false">
      <van-picker
        show-toolbar
        title="选择学员当前公立年级"
        :loading="loading"
        value-key="dictName"
        :default-index="defaultIndex"
        :columns="list"
        @confirm="confirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'GradePicker',
  data() {
    return {
      wrapshow: true,
      open: false,
      loading: true,
      //   选中的id
      dictCode: "",
      //   选中的索引
      list: [],
    };
  },
  computed: {
    defaultIndex () {
      if (!this.dictCode ||!this.list.length) return ""
      let idx = this.list.findIndex(v => v.dictCode === this.dictCode);
      return idx
    }
  },
  methods: {
    render() {
      this.$api.gradelList().then((res) => {
        if (res.code == 200) {
          this.list = res.data;
          this.loading = false;
        }
      });
    },
    showPicker(opts = {}) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;
        this.dictCode = opts.dictCode || '90';

        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
    },
    confirm(e) {
      this.close();
      this._resolve(e);
    },
  },
  created() {
    this.render();
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
